module.exports = __webpack_public_path__ + "static/media/parentportal1.a0ef9b54.svg";